import { useRef } from "react";
import QuestionLayout from "../QuestionLayout";
import AudioPlayButton from "../AudioPlayButton";

const LETTERS = ["A","B","C","D","E","F","G","H","I","J","K","L"];

export default function EarTrainingIntervalWidget({
  config,
  value = [],
  onChange,
  mode = "edit",
  feedback
}) {
  const audioRef = useRef(value._audio || {});
  const audioValue = audioRef.current;

  const useTwoSelects =
    config.sizeChoices || config.typeChoices;

  const itemCount =
    config.items?.length ??
    config.correct?.length ??
    0;

  const answers = Array.isArray(value)
    ? value
    : Array(itemCount).fill(useTwoSelects ? {} : "");

  function emit(nextAnswers) {
    nextAnswers._audio = audioRef.current;
    onChange(nextAnswers);
  }

  function setAudioState(audioState) {
    if (mode !== "edit") return;
    audioRef.current = audioState;
    emit([...answers]);
  }

  function setAnswer(i, field, v) {
    if (mode !== "edit") return;

    const next = [...answers];

    if (useTwoSelects) {
      next[i] = {
        ...(next[i] || {}),
        [field]: v
      };
    } else {
      next[i] = v;
    }

    emit(next);
  }

  return (
    <QuestionLayout
      number={config.number}
      prompt={config.prompt}
      points={config.points}
      mode={mode}
      feedback={feedback}
    >
      {config.audio && (
        <div style={{ marginBottom: 16 }}>
          <AudioPlayButton
            src={config.audio}
            value={audioValue}
            onChange={setAudioState}
            mode={mode}
            maxListens={config.maxListens ?? 1}
          />
        </div>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        {Array.from({ length: itemCount }).map((_, i) => {
          const part = feedback?.parts?.[i];
          const isCorrect = part?.correct;
          const ans = answers[i] || {};

          const border =
            mode === "review"
              ? isCorrect
                ? "2px solid #2e7d32"
                : "2px solid #c62828"
              : "1px solid #ccc";

          return (
            <div
              key={i}
              style={{
                display: "grid",
                gridTemplateColumns: "28px auto",
                alignItems: "center",
                columnGap: 12
              }}
            >
              {config.letterIndex? (
              <div style={{ fontWeight: 600, textAlign: "right" }}>
                {LETTERS[i]}.
              </div>):
              <div style={{ fontWeight: 600, textAlign: "right" }}>
                {i + 1}.
              </div>}

              {useTwoSelects ? (
                <div style={{ display: "flex", gap: 8 }}>
                  <select
                    value={ans.type || ""}
                    disabled={mode !== "edit"}
                    onChange={e => setAnswer(i, "type", e.target.value)}
                    style={{
                      width: 100,
                      padding: "6px",
                      borderRadius: 6,
                      border
                    }}
                  >
                    <option value="">Type</option>
                    {(config.typeChoices || []).map(choice => (
                      <option key={choice} value={choice}>
                        {choice}
                      </option>
                    ))}
                  </select>

                  <select
                    value={ans.size || ""}
                    disabled={mode !== "edit"}
                    onChange={e => setAnswer(i, "size", e.target.value)}
                    style={{
                      width: 80,
                      padding: "6px",
                      borderRadius: 6,
                      border
                    }}
                  >
                    <option value="">Size</option>
                    {(config.sizeChoices || []).map(choice => (
                      <option key={choice} value={choice}>
                        {choice}
                      </option>
                    ))}
                  </select>
                </div>
              ) : (
                <select
                  value={answers[i] || ""}
                  disabled={mode !== "edit"}
                  onChange={e => setAnswer(i, null, e.target.value)}
                  style={{
                    width: 80,
                    padding: "6px",
                    borderRadius: 6,
                    border
                  }}
                >
                  <option value="">—</option>
                  {(config.choices || []).map(choice => (
                    <option key={choice} value={choice}>
                      {choice}
                    </option>
                  ))}
                </select>
              )}
            </div>
          );
        })}
      </div>
    </QuestionLayout>
  );
}